import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from "../Home/Box.jsx";
import emailjs from "@emailjs/browser";
import EmailImage from "../../assets/Contact/jpeg-optimizer_email.jpeg";
import FacebookImage from "../../assets/Contact/jpeg-optimizer_facebook.jpeg";
import "./Contact.css";

export default function Contact({ title }) {
  const emailForm = useRef();
  const [emailSent, setEmailSent] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      // Get form data safely
      const formData = new FormData(emailForm.current);
      const data = Object.fromEntries(formData);

      await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID_CONTACT, // to YOU
        data,
        process.env.REACT_APP_API,
      );

      await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID_CONFIRMATION, // to USER
        data,
        process.env.REACT_APP_API,
      );

      console.log("Emails sent.");

      emailForm.current.reset();
      setEmailSent(true);
      setTimeout(() => setEmailSent(false), 3000);
    } catch (error) {
      console.error("Email failed:", error);
    }
  };

  if (!emailSent) {
    return (
      <div className="home-wrapper">
        <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
          <Row>
            <Col>
              <Box title={title} />
              <br />
              <Row>
                <center>
                  <img className="contact-image" src={EmailImage} alt="email" />
                </center>
              </Row>
              <br />
              <Row>
                <p className="contact-paragraph">
                  <b>
                    You can contact Flute Alliance by email 24/7:
                    flutealliance@gmail.com
                  </b>
                </p>
              </Row>
              <br />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <h2 className="contact-form-title">Join Our Mailing List</h2>
              <br />

              {/* ✅ SINGLE FORM ONLY */}
              <form
                className="contact-form contact-box"
                ref={emailForm}
                onSubmit={sendEmail}
              >
                <div className="frm-group">
                  <label>Name</label>
                  <input
                    required
                    type="text"
                    name="to_name"
                    className="form-control"
                    placeholder="Enter your name"
                  />

                  <label>Email</label>
                  <input
                    required
                    type="email"
                    name="to_email"
                    className="form-control"
                    placeholder="Enter your email"
                  />

                  <label>Subject</label>
                  <input
                    required
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder="Re: Flute Lessons"
                  />

                  <label>Message</label>
                  <textarea
                    required
                    name="message"
                    className="form-control"
                    rows="5"
                    placeholder="Write your message..."
                  ></textarea>

                  <button
                    type="submit"
                    className="btn btn-primary contact-button"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </Col>

            <Col md={6} style={{ paddingLeft: "8vw" }}>
              <Row>
                <br />
                <br />
                <p className="contact-like-us">
                  "Like Us" on{" "}
                  <a
                    href="https://m.facebook.com/people/Flute-Alliance/100057682182115/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                  !
                </p>
                <br />
                <Row>
                  <center>
                    <img
                      className="contact-image"
                      src={FacebookImage}
                      alt="facebook"
                    />
                  </center>
                </Row>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
          <Col>
            <Box title={title} />
            <br />
            <div className="email-sent-message">Email sent!</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
